// TODO: replace on ActionformAbstract
var FormAbstract = function ($) {

    // Abstract class
    var Self = FormAbstract = function () {
    };
    Self.className = 'FormAbstract';

    var def = function (var1, var2) {
        for (var i = 0, len = arguments.length; i < len; i++) {
            if (typeof arguments[i] !== 'undefined') {
                return arguments[i];
            }
        }
        return undefined;
    };

    Self.def = def;
    
    Self.prototype.init = function (options) {
        var that = this;
        that.initVars(options);
        that.initEventHandlers();
    };

    Self.prototype.initVars = function (options) {
        var that = this;

        options = options || {};

        that.selectors = that.selectors || {};
        // setting `next_action` and `previous_action` from `options` would be used after other signup/password restoration methods would be done
        that.selectors.next_action = def(options.next_action, that.selectors.next_action, '');
        that.selectors.previous_action = def(options.previous_action, that.selectors.previous_action, '');

        that.selectors = $.extend({

            form: 'form',

            form_input: '.input',
            form_select: '.select',
            form_select_button: '.select-button',
            form_checkbox: '.checkbox',
            form_textarea: '.textarea',
            form_file_uploader: '.file-uploader',
            form_radio_container: '.radio-container',

            form_input_error: '.error',
            form_button_submit: '.js-button-submit',
            form_wrapper: '.js-form-wrapper',
            form_title: '.js-title',

            modal: '.modal',
            modal_header_title: '.modal-header-title',
            modal_content: '.js-actionform-modal-content',

            success_wrapper: '.js-success-wrapper',
            success_sent_to: '.js-sent-to',
            button_back: '.js-button-back',
            button_goto: '.js-goto-button',

            error_alert: '.js-error-alert',
            error_alert_title: '.js-error-alert .content',
            error_msg: '.js-error-msg'

        }, that.selectors);

        that.classes = that.classes || {};
        that.classes = $.extend({

            button_loading: 'loading',
            error_input: 'error',
            error_alert_hidden: 'hidden',
            wrapper_hidden: 'hidden',
            button_hidden: 'hidden',
            modal_animation: 'animation',

        }, that.classes);

        that.data_keys = that.data_keys || {};
        that.data_keys = $.extend({

            form_action: 'action'

        }, that.data_keys);

        that.$templates = that.$templates || {};
        that.$templates = $.extend({
                error_msg: $('<div class="error-msg"></div>'),
                info_msg: $('<div class="info-msg"></div>')
            },
            that.$templates
        );

        // DOM
        that.$wrapper = def(that.$wrapper, options.$wrapper, $());
        
        that.initDomElements();

        // CONST
        // that.js_validate = def(that.js_validate, options.js_validate, true);
        that.is_ajax_mode = def(options.is_ajax_mode, that.is_ajax_mode);
        that.is_modal_mode = def(options.is_modal_mode, that.is_modal_mode);
        that.has_success_screen = def(that.has_success_screen, false);
        that.className = def(that.className, Self.className);
        that.url = def(options.url, that.url, that.getFormAction(), '');
        that.onDoneSubmitCallback = def(options.onDoneSubmitCallback, that.onDoneSubmitCallback);
        that.onAlertSubmitCallback = def(options.onAlertSubmitCallback, that.onAlertSubmitCallback);

        that.method = def(options.method, that.method, 'POST');
        that.next_url = def(options.next_url, that.next_url, null); // set it as empty string to reload current page
        
        that.response_errors = {
            large_request: 413,
            no_connect: 0
        }

        // DYNAMIC VARS
        that.errors = def(that.errors, options.errors, {});
    };

    Self.prototype.initDomElements = function () {
        var that = this;
        that.$form = that.$wrapper.find(that.selectors.form);
        if (!that.$form.length) {
            that.$form = that.$wrapper.find('form');
        }
        if (!that.$form.length) {
            that.$form = $();
        }

        that.$form_wrapper = that.$wrapper.find(that.selectors.form_wrapper);
        that.$success_wrapper = that.$wrapper.find(that.selectors.success_wrapper);

        that.$modal = that.$wrapper.parents(that.selectors.modal);
        that.$modal_title = that.$modal.find(that.selectors.modal_header_title);
        that.$modal_content = that.$modal.find(that.selectors.modal_content);

        that.$next_action = that.$modal_content.find(that.selectors.next_action);
        that.$previous_action = that.$modal_content.find(that.selectors.previous_action);

        that.$form_button_back = that.$form_wrapper.find(that.selectors.button_back);
        that.$success_button_back = that.$success_wrapper.find(that.selectors.button_back);
        that.$button_submit = that.$form.find(that.selectors.form_button_submit) || that.$form.find(':submit');
        that.$button_goto = that.$form.find(that.selectors.button_goto);

        that.$error_alert = that.$wrapper.find(that.selectors.error_alert);
        that.$error_alert_title = that.$wrapper.find(that.selectors.error_alert_title);
    }

    Self.prototype.initEventHandlers = function () {
        var that = this;
        that.$button_submit.on('click', function (e) {
            that.onSubmit(e);
        });
        that.$success_button_back.on('click', function (e) {
            that.backFromSuccess();
        });
        that.$form_button_back.on('click', function (e) {
            that.toPreviousAction();
        });
        that.$button_goto.on('click', function (e) {
            e.preventDefault();
            that.toAction($(this).data('goto'));
        });
    };

    Self.prototype.onSubmit = function (e) {
        var that = this;
        if (!that.is_ajax_mode) {
            return;
        }
        e.preventDefault();
        return that.submit();
    };

    Self.prototype.submit = function (options) {

        options = options || {};

        var that = this;

        that.beforeSubmit();

        that.clearErrors();

        // TODO: validate (?)
        // if (that.js_validate) {
        //     var errors = that.validate();
        //     if (!$.isEmptyObject(errors)) {
        //         that.showErrors(errors);
        //         return;
        //     }
        // }

        var $button = options.$button || that.$button_submit,
            url = options.url || that.url,
            method = options.method || that.method,
            data = that.getSerializedFormData();

        $button.addClass(that.classes.button_loading);
        $button.prop('disabled', true);

        return that.jsonSend(url, method, data)
            .done(function (response) {
                if (!that.isRedirectResponse(response) || !that.isResponseSuccessful(response) || !that.needRedirect()) {
                    // On 'redirect' response
                    // DO NOT hide loading and enable button right away
                    // for UI/UX reason
                    $button.prop('disabled', false);
                    $button.removeClass(that.classes.button_loading);
                }
                that.onDoneSubmit(response);
            })
            .fail(function (jqXHR) {
                that.__showSubmitErrorModal(jqXHR.status);
                $button.prop('disabled', false);
                $button.removeClass(that.classes.button_loading);
                that.showErrors([{message: jqXHR.responseText}]);
            })
            .always(function (response) {
                that.onAlwaysSubmit(response);
            });
    };

    Self.prototype.beforeSubmit = function () {
        var that = this;

        var getCsrfToken = function() {
            var matches = document.cookie.match(new RegExp("(?:^|; )_csrf=([^;]*)"));
            if (!matches || !matches[1]) {
                return '';
            }
            return decodeURIComponent(matches[1]);
        };

        // Update csrf token right before submit
        // in case it changed via another browser tab
        var $csrf_hidden_field = that.$form.find('[name="_csrf"]');
        $csrf_hidden_field.val(getCsrfToken);
    };
    
    Self.prototype.onDoneSubmit = function (response) {
        var that = this,
            handlers = that.onDoneSubmitHandlers(),
            ok = that.isResponseSuccessful(response),
            data = (response && response.data) || {},
            messages = data.messages || {},
            errors = (response && response.errors) || {},
            stop = false;

        if (!ok) {
            stop = (handlers.errors && handlers.errors(errors, response));
            if (stop) {
                return;
            }
        }

        if (that.isRedirectResponse(response) && (!that.isModalMode() || that.needRedirect())) {
            var url = that.getRedirectUrl(response);
            stop = (handlers.redirect && handlers.redirect(url));
            if (stop) {
                return;
            }
        }
        else if (that.isModalMode()) {
            stop = (handlers.goToNext && handlers.goToNext(response));
            if (stop) {
                return;
            }
        }

        if (!$.isEmptyObject(messages)) {
            stop = (handlers.messages && handlers.messages(messages));
            if (stop) {
                return;
            }
        }

        that.onDoneSubmitCallback && that.onDoneSubmitCallback(response)

        handlers.rest && handlers.rest(response);
    }
    
    Self.prototype.__showSubmitErrorModal = function (error_code) {
        var that = this,
            error_msg = null;
        
        switch (error_code) {
            case that.response_errors.large_request:
                error_msg = $.sa.locales.abstract_form.error_message.too_large_request;
                break;
            case that.response_errors.no_connect:
                error_msg = $.sa.locales.abstract_form.error_message.no_connect;
                break;
        }
        
        if (!error_msg) {
            return;
        }

        $.sa.alert.show({
            title: that.locales.error_title || $.sa.locales.abstract_form.error_message.error_title,
            content: error_msg,
            button: that.locales.confirm_text || $.sa.locales.abstract_form.confirm_text,
        });
    }

    Self.prototype.onDoneSubmitHandlers = function () {
        var that = this;
        return {
            errors: function (errors, response) {
                that.showErrors(errors);
                return true;
            },
            redirect: function (url) {
                // if url is not string and empty (null for example) - do nothing
                if (!url && typeof url !== 'string') {
                    return;
                } else if (
                    url.length === 0 || // if url is undefined or empty, reload current page
                    (url.indexOf('#') !== -1 && url === window.location.href)
                    ) {
                    window.location.reload();
                } else {
                    $.sa.content_router.load(url);
                }
                return true;
            },
            goToNext: function(response) {
                if (that.hasSuccessScreen()) {
                    that.toSuccess();
                } else {
                    that.toNextAction();
                }
                return true;
            },
            messages: function (messages) {
                that.showInfoMessages(messages);
                return true;
            },
            rest: function (response) {
                return true;
            }
        };
    };

    Self.prototype.onAlwaysSubmit = function (response) {
        // TODO: captcha (?)
        // if (!that.isRedirectResponse(response)) {
        //     // Not need call redundant refresh request
        //     $('.wa-captcha-refresh').trigger('click');
        // }
    };

    Self.prototype.clearErrors = function () {
        var that = this;
        that.hideErrorAlert();
        that.hideInputErrors();
        that.clearInputErrors();
    }

    Self.prototype.showErrors = function (errors) {
        var that = this,
            scrolled_error_input = false;
        errors = errors || [];
        
        if (errors.length > 0) {
            errors.forEach(function(error) {
                if (error.hasOwnProperty('_alert') && error._alert !== null) {
                    // so only one alert could be displayed (currently, it's the last one)
                    that.setErrorAlert(error.hasOwnProperty('_alert') ? error._alert : '');
                    that.showErrorAlert();
                    that.onAlertSubmitCallback && that.onAlertSubmitCallback(error)
                }

                if (error.hasOwnProperty('_input') && error._input !== null) {
                    var input_errors = error._input;
                    for(var error_name in input_errors) {
                        var error_list = input_errors[error_name];
                        var res = that.displayInputErrors(error_name, error_list);
                        if (!res) {
                            that.displayUncaughtErrors(error_name, error_list);
                        }
                        
                        if (!scrolled_error_input) {
                            scrolled_error_input = that.scrollToErrorInput(error_name);
                        }
                    }
                }

                if (
                    !error.hasOwnProperty('_alert') && 
                    !error.hasOwnProperty('_input') &&
                    error.hasOwnProperty('message')
                ) {
                    that.displayUncaughtErrors('unknown', error.message);
                }
            });
        }
    }

    Self.prototype.scrollToErrorInput = function (input_name) {
        var that = this,
            $input = that.getFormInput(input_name);
        
        if (!$input.length) {
            return false;
        }
        
        var $parent_element = $input.closest('.' + that.classes.error_input);
        
        if (!$parent_element) {
            return false;
        }
       
        $.sa.scrollToNode($parent_element, 300, -10);
        
        return true;
    }
    
    Self.prototype.__getInputParent = function ($input) {
        
    }

    Self.prototype.setErrorAlert = function (error_text = '') {
        if (!error_text) {
            error_text = this.getLocalePhrase('error');
        }
        this.$error_alert_title.text(error_text);
    }

    Self.prototype.showErrorAlert = function () {
        this.$error_alert.removeClass(this.classes.error_alert_hidden);
    }

    Self.prototype.hideErrorAlert = function () {
        this.$error_alert.addClass(this.classes.error_alert_hidden);
    }

    Self.prototype.setInputError = function ($input, error_text = '') {
        var that = this,
            text;
        // if error_text is `false` - do not display error message
        if (error_text === false) {
            text = '';
        }
        // if error_text is empty - set default input error text
        else if (error_text.length === 0) {
            text = that.getLocalePhrase('error');
        } else {
            text = error_text;
        }

        that.iterateInputTypes($input, function ($input) {
            $input.find(that.selectors.form_input_error).append(that.prepareErrorTemplate(text));
        })
    }

    Self.prototype.displayInputErrors = function (name, error_list) {
        var that = this,
            $input = that.getFormInput(name);
        if (!$input.length) {
            return false;
        }

        if (Array.isArray(error_list)) {
            error_list.forEach(function (error_text) {
                that.setInputError($input, error_text);
            });
        } else {
            that.setInputError($input, error_list);
        }
        that.iterateInputTypes($input, function ($input) {
            $input.addClass(that.classes.error_input)
        })

        return true;
    }

    Self.prototype.hideInputErrors = function () {
        var that = this,
            $inputs = that.getFormInputs();
        $inputs.each(function () {
            $(this).removeClass(that.classes.error_input);
        });
    }

    Self.prototype.clearInputErrors = function () {
        var that = this,
            $inputs = that.getFormInputs();
        $inputs.each(function () {
            $(this).find(that.selectors.form_input_error).html('');
        });
    }

    Self.prototype.displayUncaughtErrors = function (name, errors) {
        // TODO: define
        var that = this,
            error_text = '';
        if (Array.isArray(errors)) {
            errors.forEach(function (error) {
                error_text += error.message + '; ';
            });
        } else {
            error_text += errors;
        }
        $.sa.error(`Uncaught error "${name}": ${error_text}`);
    }

    Self.prototype.showInfoMessages = function (messages) {
        // TODO: define
    }

    Self.prototype.prepareErrorTemplate = function (error) {
        var that = this,
            $error_template = that.$templates.error_msg.clone();
        return $error_template.text(error);
    }

    Self.prototype.isModalMode = function () {
        return this.is_modal_mode;
    };

    // for those actions that require redirect even in modal mode;
    // they should override this property;
    // by default, redirect is needed in non-modal mode
    Self.prototype.needRedirect = function () {
        return !this.is_modal_mode;
    };

    Self.prototype.hasSuccessScreen = function () {
        return this.has_success_screen;
    };

    Self.prototype.jsonSend = function (url, method, data) {
        return $.ajax(
            url, 
            {
                method: method,
                data: data,
                processData: false, // нужно для отправки файлов
                contentType: false, // нужно для отправки файлов
                dataType: 'json'
            }
        );
    }

    Self.prototype.isResponseSuccessful = function (response) {
        return response && response.status === 'ok';
    }

    Self.prototype.isRedirectResponse = function (response) {
        return this.getRedirectUrl(response) !== null;
    };

    Self.prototype.getRedirectUrl = function (response) {
        var that = this,
            url = that.isResponseSuccessful(response) && response.data && response.data.redirect_url ? response.data.redirect_url : null;
        if (typeof url === 'string' && url.length > 0) {
            return url;
        } else if (typeof that.next_url === 'string' && that.next_url.length > 0) {
            return that.next_url;
        } else {
            return null;
        }
    };

    Self.prototype.toNextAction = function () {
        var that = this,
            $next_action_wrapper = that.$next_action.parents(that.selectors.form_wrapper);
        that._animateGoTo(that.$form_wrapper, $next_action_wrapper, 'forward');
        that._showAction(that.$next_action);
        that._showActionBackButton(that.$next_action);
    };

    Self.prototype.toPreviousAction = function () {
        var that = this,
            $previous_action_wrapper = that.$previous_action.parents(that.selectors.form_wrapper);
        that._animateGoTo(that.$form_wrapper, $previous_action_wrapper, 'back');
        that._showAction(that.$previous_action);
    };

    Self.prototype.toAction = function (action_class) {
        var that = this,
            $action = $('.' + action_class),
            $action_wrapper = $action.parents(that.selectors.form_wrapper);
        that._animateGoTo(that.$form_wrapper, $action_wrapper, 'forward');
        that._showAction($action);
        that._showActionBackButton($action);
    };

    Self.prototype._showAction = function ($action) {
        var that = this,
            $action_title = $action.find(that.selectors.form_title);
        that._setModalTitle($action_title.text());
    };

    Self.prototype._showActionBackButton = function ($action) {
        var that = this,
            $action_wrapper = $action.parents(that.selectors.form_wrapper),
            $action_back_button = $action_wrapper.find(that.selectors.button_back);
        $action_back_button.removeClass(that.classes.button_hidden);
    };

    Self.prototype.toSuccess = function () {
        var that = this;
        that._animateGoTo(that.$form_wrapper, that.$success_wrapper, 'forward');
    };

    Self.prototype.backFromSuccess = function () {
        var that = this;
        that._animateGoTo(that.$success_wrapper, that.$form_wrapper, 'back');
    };

    Self.prototype._animateGoTo = function ($elem_from, $elem_to, direction) {
        var that = this,
            animation_show_class,
            animation_hide_class;

        if (direction === 'forward') {
            animation_show_class = 'fadeInRight';
            animation_hide_class = 'fadeOutLeft';
        } else if (direction === 'back') {
            animation_show_class = 'fadeInLeft';
            animation_hide_class = 'fadeOutRight';
        } else {
            return;
        }

        that.$modal_content.addClass(that.classes.modal_animation);

        $elem_from.removeClass(that.classes.wrapper_hidden)
            .addClass('animated')
            .addClass('faster')
            .removeClass(animation_show_class)
            .addClass(animation_hide_class);

        $elem_to.removeClass(that.classes.wrapper_hidden)
            .addClass('animated')
            .addClass('faster')
            .removeClass(animation_hide_class)
            .addClass(animation_show_class);

        $elem_from.addClass(that.classes.wrapper_hidden);

        setTimeout(function () {
            that.$modal_content.removeClass(that.classes.modal_animation);
            // clear animation classes
            $elem_from.removeClass(animation_hide_class).removeClass('animated').removeClass('faster');
            $elem_to.removeClass(animation_show_class).removeClass('animated').removeClass('faster');
        }, 500);
    };

    Self.prototype._setModalTitle = function (title) {
        var that = this;
        that.$modal_title.text(title);
    };

    Self.prototype.getFormAction = function () {
        var that = this;
        if (that.$form.is('form')) {
            return that.$form.attr('action');
        } else {
            return that.$form.data(that.data_keys.form_action);
        }
    };

    /**
     * Set of form inputs/selects could be changed dynamically,
     * so it must be better decision to get them dynamically, not on init
     */
    Self.prototype.getFormInputs = function () {
        var that = this;
        return that.__mergeJqElements(
            that.$form.find(that.selectors.form_input),
            that.$form.find(that.selectors.form_select),
            that.$form.find(that.selectors.form_select_button),
            that.$form.find(that.selectors.form_checkbox),
            that.$form.find(that.selectors.form_textarea),
            that.$form.find(that.selectors.form_file_uploader),
            that.$form.find(that.selectors.form_radio_container)
        )
    }

    Self.prototype.getFormInput = function (name) {
        var that = this;
        return that.$form.find('[name="' + name + '"]');
    }

    Self.prototype.iterateInputTypes = function ($input, cb) {
        var that = this;

        cb($input.parent(that.selectors.form_input)),
        cb($input.closest(that.selectors.form_radio_container))    
        cb($input.parent(that.selectors.form_select))
        cb($input.closest(that.selectors.form_select_button))
        cb($input.parent(that.selectors.form_checkbox))
        cb($input.parent(that.selectors.form_textarea))
        cb($input.closest(that.selectors.form_file_uploader))
    }

    Self.prototype.getSerializedFormData = function () {
        var that = this;
        if (that.$form.is('form')) {
            // return that.$form.serializeArray();
            return new FormData(that.$form[0]) // нужно для отправки файлов
        } else {
            return that.$form.find(':input').serializeArray();
        }
    };

    Self.prototype.getLocalePhrase = function (phrase_key) {
        var that = this;
        if (that.locales.hasOwnProperty(phrase_key)) {
            return that.locales[phrase_key];
        } else if ($.sa.locales.hasOwnProperty(phrase_key)) {
            return $.sa.locales[phrase_key];
        } else {
            return '[no text]';
        }
    }

    Self.prototype.__mergeJqElements = function ($el1, $el2) {
        var $result = arguments[0]

        for (var i = 1, len = arguments.length; i < len; i++) {
            $result = $.merge($result, arguments[i])
        }

        return $result
    }

    Self.prototype.__updateRemoveButtons = function (select_remove_button) {
        $(select_remove_button).show()
        $(select_remove_button).first().hide()
    }

    Self.prototype.__updateAddButtons = function (select_add_button) {
        $(select_add_button).hide()
        $(select_add_button).last().show()
    }

    Self.prototype.initGroupBlocks = function (select_block, select_add_button, select_remove_button, copied_block, update_index) {
        var that = this;

        that.__updateRemoveButtons(select_remove_button)
        update_index()

        $.sa.$document.on('click', select_add_button, function (e) {
            var $button_add = $(e.target)
            var $refund_block = $button_add.closest(select_block)

            if ($button_add.hasClass(select_add_button.substring(1)) && $refund_block) {
                $refund_block.after(copied_block.clone())
                that.__updateRemoveButtons(select_remove_button)
                that.__updateAddButtons(select_add_button)
                update_index()
            }
        });

        $.sa.$document.on('click', select_remove_button, function (e) {
            var $button_remove = $(e.target)
            var $refund_block = $button_remove.closest(select_block)

            if ($button_remove.hasClass(select_remove_button.substring(1)) && $refund_block) {
                $refund_block.remove()
                that.__updateRemoveButtons(select_remove_button)
                that.__updateAddButtons(select_add_button)
                update_index()
            }
        });
    }

    return Self;
}(jQuery);